import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { C33IconCTALeftAlignedProps } from './C33IconCTALeftAligned.types';
import { IconCtaLeftAlignedProps } from '@ahc-digital/component-library';
import { ICON_CTA_LEFT_ALIGNED_CARDS } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function CreateIconCTALeftAlignedModel(
  props?: C33IconCTALeftAlignedProps
): IconCtaLeftAlignedProps {
  type t = IconCtaLeftAlignedProps;
  const { rendering, params, fields } = props || {};
  const { renderRichText, renderText, renderLink } = useConditionalRendering();
  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    bottomSupportCopy: renderRichText(fields?.BottomSupportCopy),
    children: rendering && <Placeholder name={ICON_CTA_LEFT_ALIGNED_CARDS} rendering={rendering} />,
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    numberOfColumns: getDroplink<t['numberOfColumns']>(params?.NumberOfColumns, '2'),
    supportCopyAlignment: getDroplink<t['supportCopyAlignment']>(
      params?.SupportCopyAlignment,
      'center'
    ),
    headlineAlignment: getDroplink<t['headlineAlignment']>(params?.HeadlineAlignment, 'center'),
    wrapperCta: renderLink(fields?.CTA),
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    contentLayout: getDroplink<t['contentLayout']>(params?.LayoutStyle, 'default'),
    layoutStyle: getDroplink<t['layoutStyle']>(params?.ContentLayout, 'vertical'),
    contentWidth: getDroplink<t['contentWidth']>(params?.ContentWidth, 'wide'),
  };
}
